export default __webpack_public_path__ + "static/media/295.c5ea147b.jpg";